var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DD353F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.855 20.928c0 11.005-8.922 19.927-19.927 19.927C9.922 40.855 1 31.933 1 20.928 1 9.922 9.922 1 20.928 1c11.005 0 19.927 8.922 19.927 19.928zM20.928 1v3.623M10.964 3.67l1.811 3.137M3.67 10.964l3.137 1.811M1 20.928h3.623M38.185 10.964l-3.137 1.811M30.891 3.67L29.08 6.807M1.906 26.362h13.587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.493 26.362a5.434 5.434 0 1 1 10.87 0h13.586M22.74 20.928l3.622-9.964"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiIgdmlld0JveD0iMCAwIDQyIDQyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREQzNTNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxwYXRoIGQ9Ik00MC44NTUgMjAuOTI4YzAgMTEuMDA1LTguOTIyIDE5LjkyNy0xOS45MjcgMTkuOTI3QzkuOTIyIDQwLjg1NSAxIDMxLjkzMyAxIDIwLjkyOCAxIDkuOTIyIDkuOTIyIDEgMjAuOTI4IDFjMTEuMDA1IDAgMTkuOTI3IDguOTIyIDE5LjkyNyAxOS45Mjh6TTIwLjkyOCAxdjMuNjIzTTEwLjk2NCAzLjY3bDEuODExIDMuMTM3TTMuNjcgMTAuOTY0bDMuMTM3IDEuODExTTEgMjAuOTI4aDMuNjIzTTM4LjE4NSAxMC45NjRsLTMuMTM3IDEuODExTTMwLjg5MSAzLjY3TDI5LjA4IDYuODA3TTEuOTA2IDI2LjM2MmgxMy41ODciLz4KICAgICAgICA8cGF0aCBkPSJNMTUuNDkzIDI2LjM2MmE1LjQzNCA1LjQzNCAwIDEgMSAxMC44NyAwaDEzLjU4Nk0yMi43NCAyMC45MjhsMy42MjItOS45NjQiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };